export default __webpack_public_path__ + "static/media/address-icon.3d77c0d7.svg";